export class EmploymentInfo {
  constructor(
    employerName = '',
    yearsEmployed = null,
    monthsEmployed = null,
    jobDescription = '',
    activeIncomeVerification = null
  ) {
    this.employerName = employerName;
    this.yearsEmployed = yearsEmployed;
    this.monthsEmployed = monthsEmployed;
    this.jobDescription = jobDescription;
    this.activeIncomeVerification = activeIncomeVerification;
  }
}

export class CurrentAddress {
  constructor(
    street = '',
    aptNumber = null,
    city = '',
    stateCode = '',
    zipCode = ''
  ) {
    this.street = street;
    this.aptNumber = aptNumber;
    this.city = city;
    this.stateCode = stateCode;
    this.zipCode = zipCode;
  }
}

export class Applicant {
  constructor(
    firstName = '',
    lastName = '',
    emailAddress = '',
    confirmEmailAddress = '',
    phoneNumber = '',
    phoneType = 'mobile',
    smsOptIn = false,
    currentAddress = new CurrentAddress(),
    currentAddressType = 'other',
    ssn = '',
    dateOfBirth = '',
    employmentStatus = '',
    employmentInfo = new EmploymentInfo(),
    incomeAmount = null,
    otherIncome = null,
    incomeFrequency = '',
    otherIncomeFrequency = '',
    profileReferenceId = '',
    prospectId = '',
    externalId = '',
    clientCorrelationId = '',
    isSameAddress = null
  ) {
    this.lastName = lastName;
    this.firstName = firstName;
    this.emailAddress = emailAddress;
    this.confirmEmailAddress = confirmEmailAddress;
    this.phoneNumber = phoneNumber;
    this.phoneType = phoneType;
    this.smsOptIn = smsOptIn;
    this.currentAddress = currentAddress;
    this.currentAddressType = currentAddressType;
    this.ssn = ssn;
    this.dateOfBirth = dateOfBirth;
    this.employmentStatus = employmentStatus;
    this.employmentInfo = employmentInfo;
    this.incomeAmount = incomeAmount;
    this.otherIncome = otherIncome;
    this.profileReferenceId = profileReferenceId;
    this.prospectId = prospectId;
    this.externalId = externalId;
    this.clientCorrelationId = clientCorrelationId;
    this.isSameAddress = isSameAddress;
    this.incomeFrequency = incomeFrequency;
    this.otherIncomeFrequency = otherIncomeFrequency;
  }
}

export class Application {
  constructor(
    loanType = 'REFINANCE',
    applicationType = 'INDIVIDUAL',
    profileType = 'financial',
    agreeToLookup = null,
    agreeToTerms = null,
    primaryApplicant = new Applicant(),
    coApplicant = new Applicant(),
    year = '',
    make = '',
    model = '',
    trim = '',
    vin = '',
    wholeSaleValue = '',
    promoCode = '',
    paymentDueDay = null,
    manualEntryFlag = null,
    selectedLoan = null,
    isPrefilled = null
  ) {
    this.loanType = loanType;
    this.applicationType = applicationType;
    this.profileType = profileType;
    this.primaryApplicant = primaryApplicant;
    this.coApplicant = coApplicant;
    this.promoCode = promoCode;
    this.agreeToTerms = agreeToTerms;
    this.agreeToLookup = agreeToLookup;
    this.year = year;
    this.make = make;
    this.model = model;
    this.trim = trim;
    this.vin = vin;
    this.wholeSaleValue = wholeSaleValue;
    this.paymentDueDay = paymentDueDay;
    this.manualEntryFlag = manualEntryFlag;
    this.selectedLoan = selectedLoan;
    this.isPrefilled = isPrefilled;
  }
}
